export default function SelectSpecialCondition(state, payload){
  const {specialCondition} = payload;
  state.selectedSpecialConditions[specialCondition.id] = specialCondition;
  return {...state}
}